









import { Vue, Component, Inject } from "vue-property-decorator";
import { IUserProviderData } from "@/models/providers/user";

@Component({
  components: {
    "users-form": () => import("@/components/app/admin/users/usersForm.vue")
  }
})
export default class AdminUserOverview extends Vue {
  // Inject
  @Inject({ from: "userProvider" })
  public readonly $userProvider!: () => IUserProviderData;

  public get $userData() {
    return this.$userProvider();
  }
}
